import React from 'react';
import { useTranslation } from 'react-i18next';
import { LIVES_ICON } from '../../lair/utils/lairAssets';
import './lifeLost.css';

/** End screens of Match-3 / Solitaire (v1.51.0): a lost game costs a life. */
export default function LifeLost() {
  const { t } = useTranslation();
  return (
    <div className="game-life-lost" data-testid="life-lost">
      <img src={LIVES_ICON} alt="" />
      <span>{t('lives.lost', '−1 life')}</span>
    </div>
  );
}
